export const defaultNewsletterField = [
  "newsletter_email",
  "createdAt",
  "subscribe",
];


export const NEWSLETTER_SORT_FIELDS = [
  "newsletter_email",
  "createdAt",
  "subscribe",
]